import React from 'react';
import { useLocation } from 'react-router-dom';
import { Table } from 'react-bootstrap';

const SearchResult = () => {
  const location = useLocation();
  const searchResults = location.state && location.state.searchResults;

  if (!searchResults || searchResults.length === 0) {
    return <div>Нет результатов поиска</div>;
  }

  return (
    <div>
      {searchResults.length > 0 && (
        <div>
          <h2>Результаты поиска:</h2>
          <Table striped bordered hover variant="dark"  responsive>
          <thead>
        <tr>
          <th>Название:</th>
          {searchResults.map((item) => (
            <th key={item.id}>{item.name}</th>
          ))}
        </tr>
      </thead>
      <thead>
        <tr>
          <th>Код товара:</th>
          {searchResults.map((item) => (
            <th key={item.id}>{item.productCode}</th>
          ))}
        </tr>
      </thead>
      <thead>
        <tr>
          <th>Размер:</th>
          {searchResults.map((item) => (
            <th key={item.id}>{item.size}</th>
          ))}
        </tr>
      </thead>
      <thead>
        <tr>
          <th>Брэнд:</th>
          {searchResults.map((item) => (
            <th key={item.id}>{item.brand}</th>
          ))}
        </tr>
      </thead>
      <thead>
        <tr>
          <th>Артикул:</th>
          {searchResults.map((item) => (
            <th key={item.id}>{item.tigerCode}</th>
          ))}
        </tr>
      </thead>
      </Table>
        </div>
      )}
    </div>
  );
};

export default SearchResult;